import React, { useState, useEffect } from 'react'
import { db } from '../../firebase.js'
import RoomStatus from './RoomStatus.js'

export default function TableRow(obj) {
  //set default state to not found.  Some legacy rooms have no stripe data in the json so we will skip over them and leave this default
  const [subscriptionData, setSubscriptionData] = useState({
    id: 'not found in data',
    active: 'n/a',
  })
  const [roomLocked, setRoomLocked] = useState('Waiting to populate')
  // Check if string is email so we dont pass bad requests to Stripe API
  function isEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }

  async function getSubscriptionData(obj) {
    let customerId = obj.data.customer_id

    if (customerId === undefined || isEmail(customerId)) {
      //   console.log('no cust id - fetching data from stripe')
      const url = `https://api.stripe.com/v1/customers?email=${obj.data.owner_email}&limit=10`

      const options = {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_LIVE}`,
        },
      }

      const response = await fetch(url, options)
      const json = await response.json()

      if (json.data[0]) {
        customerId = await json.data[0].id
      } else {
        return false
      }
    }
    if (
      subscriptionData.id !== 'not found in data' &&
      subscriptionData.active !== 'n/a' &&
      !obj.isSearched
    ) {
      //   console.log('sub data already set')
      return false
    }

    const url = `https://api.stripe.com/v1/subscriptions?customer=${customerId}&status=all`
    const options = {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_LIVE}`,
      },
    }

    const response = await fetch(url, options)

    //initialize varible to hold our data from the API
    var subscription
    // if customer id isn't in stripe then return false
    if (response.ok === false) {
      subscription = false
    } else {
      const json = await response.json()
      // store our subscription in variable
      subscription = json.data[0]
    }
    // if subscription is found the format the data so we can populate our table
    if (subscription) {
      let subscriptionData = {
        id: subscription.id,
        active: 'Inactive',
      }

      if (subscription.ended_at == null) {
        subscriptionData.active = 'Active'
      }

      setSubscriptionData(subscriptionData)
      return subscriptionData
    } else {
      return false
    }
  }

  async function isRoomLocked(roomId) {
    let ref = db.ref(roomId + '/locked')
    ref.on('value', (snapshot) => {
      const locked = snapshot.val()
      if (locked === true) {
        setRoomLocked('locked')
      } else {
        setRoomLocked('unlocked')
      }
    })
  }

  function activeClassSelector() {
    if (subscriptionData.active === 'Active') {
      return (
        <td className='admin-panel-active' data-label='Subscription Status'>
          {' '}
          {subscriptionData.active}{' '}
        </td>
      )
    } else {
      return (
        <td data-label='Subscription Status'> {subscriptionData.active} </td>
      )
    }
  }

  useEffect(() => {
    let unmounted = false

    if (!unmounted) {
      getSubscriptionData(obj)
      isRoomLocked(obj.data.room_name)
    }

    return () => {
      unmounted = true
    }
  }, [obj])

  return (
    <tr className={obj.dark ? `bg-black` : ``}>
      <td data-label='Email'> {obj.data.owner_email} </td>
      <td data-label='Room Link'>
        <a href={`room/${obj.data.room_name}`}>https://app.branding.cards/room/{obj.data.room_name}</a>
      </td>
      <td data-label='Room Key'> {obj.data.key} </td>
      <td data-label='Subscription Id'>{subscriptionData.id} </td>
      {activeClassSelector()}
      <td data-label='Room Status'>
        <RoomStatus locked={roomLocked} roomId={obj.data.room_name} />
      </td>
    </tr>
  )
}
